
    import {
      withCompInfo,
      createComponentMapperModel,
    } from '@wix/editor-elements-integrations';

    const props = withCompInfo<any, any>()(
      ['compData'],
      ({ compData }) => {
        return {
          ...{"alignTextToCenter":false,"richTextLink":"","richTextLabel":"","richTextContent":"Your placeholder text goes here. Write, style and link it."},
          ...compData,
          
        };
      },
    );

    export default createComponentMapperModel({
      props,
    });
  